import type { ReactNode } from 'react';
import styles from './OpportunityGrid.module.css';

interface OpportunityGridProps {
  columns?: 2 | 3;
  children: ReactNode;
}

export function OpportunityGrid({ columns = 3, children }: OpportunityGridProps) {
  return (
    <div
      className={styles.grid}
      style={{ ['--cols' as never]: columns }}
    >
      {children}
    </div>
  );
}

interface OpportunityCardProps {
  /** Eyebrow label inside the card — typically a number like "01" or a label. */
  eyebrow?: ReactNode;
  /** Card title. */
  title: ReactNode;
  children: ReactNode;
}

export function OpportunityCard({ eyebrow, title, children }: OpportunityCardProps) {
  return (
    <div className={styles.card}>
      {eyebrow && <span className={styles.eyebrow}>{eyebrow}</span>}
      <h4 className={styles.title}>{title}</h4>
      <p className={styles.body}>{children}</p>
    </div>
  );
}
